
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ChZM", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

var $7sObp = parcelRequire("7sObp");


var $btHGY = parcelRequire("btHGY");


var $inPa6 = parcelRequire("inPa6");


var $1iSzD = parcelRequire("1iSzD");


var $e4o8D = parcelRequire("e4o8D");


var $iP9x4 = parcelRequire("iP9x4");


var $4IoVL = parcelRequire("4IoVL");


var $gXrHX = parcelRequire("gXrHX");


var $jVylI = parcelRequire("jVylI");


var $zalpJ = parcelRequire("zalpJ");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $luv00 = parcelRequire("luv00");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $75Ax4 = parcelRequire("75Ax4");


var $2XV0z = parcelRequire("2XV0z");


var $3WPGR = parcelRequire("3WPGR");

const $250035b51418e050$export$75f07c36086c2c81 = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "img" : t2;
        const { isPresenterMode: isPresenterMode, presenterModeHeight: presenterModeHeight, smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFullWidthImageOption: isFullWidthImageOption, isFixedWidthImageOption: isFixedWidthImageOption, dynamicCoverImageHeight: dynamicCoverImageHeight, isPagePreview: isPagePreview, isObjectHeaderEnabled: isObjectHeaderEnabled, isSpaceOverview: isSpaceOverview, hasEmoji: hasEmoji, objectPosition: objectPosition, isRoundedCorners: isRoundedCorners, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_12lctvr": (0, $7sObp.default)(__cmplp.presenterModeHeight, "px"),
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px"),
                "--_pjvxvw": (0, $7sObp.default)(__cmplp.dynamicCoverImageHeight, "px"),
                "--_z440ka": (0, $7sObp.default)(__cmplp.objectPosition)
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_5ral1dfr _1bsb1osq _1e0c1txw _rsuf3crg",
                __cmplp.isPresenterMode ? "_4t3i1w4h" : __cmplp.smartSpaceOverviewHeight ? "_4t3i6qgo" : __cmplp.isFullWidthImageOption ? "_4t3i1a28" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3ifmv9",
                __cmplp.isFixedWidthImageOption && "_1bsb1c3h",
                __cmplp.smartSpaceOverviewHeight ? "_19pkze3t" : !__cmplp.isPagePreview && "_19pkpxbi",
                __cmplp.smartSpaceOverviewHeight ? "_otyrze3t" : __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isSpaceOverview && __cmplp.hasEmoji ? "_otyrpxbi" : __cmplp.isPagePreview ? "_otyrze3t" : "_otyrxy5q",
                __cmplp.isRoundedCorners ? "_2rkopb1k" : "_2rkon7od",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $250035b51418e050$export$caf7b844f87776ef = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, isObjectHeaderEnabled: isObjectHeaderEnabled, isPagePreview: isPagePreview, isSpaceOverview: isSpaceOverview, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7izff _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
                __cmplp.isFixedWidthImageOption ? "_18u09b24 _p12f1c3h" : "_18u09b24",
                __cmplp.smartSpaceOverviewHeight ? "_otyrze3t" : __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : __cmplp.isPagePreview || __cmplp.isSpaceOverview ? "_otyrpxbi" : "_otyrxy5q",
                __cmplp.smartSpaceOverviewHeight ? "_19pkze3t" : "_19pkpxbi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $250035b51418e050$export$4f4221086883a54f = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { smartSpaceOverviewHeight: smartSpaceOverviewHeight, isFixedWidthImageOption: isFixedWidthImageOption, isSpaceOverview: isSpaceOverview, isEmbeddedConfluence: isEmbeddedConfluence, hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded, isObjectHeaderEnabled: isObjectHeaderEnabled, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_19y14qn": (0, $7sObp.default)(__cmplp.smartSpaceOverviewHeight, "px")
            },
            ref: __cmplr,
            className: (0, $gMc0m.default)([
                "_11q7izff _1e0c1txw _1bah1h6o _4cvr1h6o _kqswstnw",
                __cmplp.smartSpaceOverviewHeight ? "_4t3ihojm" : __cmplp.isFixedWidthImageOption ? "_4t3i2pqz" : "_4t3i1a28",
                __cmplp.isFixedWidthImageOption ? "_1bsb1c3h" : __cmplp.isSpaceOverview || __cmplp.isEmbeddedConfluence ? "_1bsb1osq" : "_1bsb14oa",
                __cmplp.hasAllowedExternalImageLoaded ? "_3um015vq" : "_3um0ewfl",
                __cmplp.smartSpaceOverviewHeight ? "_otyrze3t" : __cmplp.isObjectHeaderEnabled ? "_otyrze3t" : "_otyrpxbi",
                __cmplp.smartSpaceOverviewHeight ? "_19pkze3t" : "_19pkpxbi",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $250035b51418e050$var$AllowedExternalWrapper = /*#__PURE__*/ (0, $42omo.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $frIzR.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $gMc0m.default)([
            "_2rkon7od _1e0c1txw _1bah1h6o",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $250035b51418e050$var$IdentifierWrapper = (t0)=>{
    const $ = (0, $frIzR.c)(9);
    const { children: children, isPagePreview: isPagePreview, isEmbeddedConfluence: t1, isFixedWidthImageOption: t2, isSmartSpaceOverview: t3 } = t0;
    const isEmbeddedConfluence = t1 === undefined ? false : t1;
    const isFixedWidthImageOption = t2 === undefined ? false : t2;
    const isSmartSpaceOverview = t3 === undefined ? false : t3;
    const t4 = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    let t5;
    if ($[0] !== isEmbeddedConfluence || $[1] !== isFixedWidthImageOption || $[2] !== isPagePreview || $[3] !== isSmartSpaceOverview) {
        t5 = isPagePreview && isFixedWidthImageOption ? {
            display: "flex",
            justifyContent: "center"
        } : !isPagePreview && !isSmartSpaceOverview ? isFixedWidthImageOption ? {
            marginLeft: "var(--full-cover-image-margin, 0px)",
            width: isEmbeddedConfluence ? "unset" : "var(--full-cover-image-width, 100%)",
            marginTop: "-26px",
            display: isFixedWidthImageOption ? "flex" : "unset",
            justifyContent: isFixedWidthImageOption ? "center" : "unset"
        } : {
            marginLeft: "var(--full-cover-image-margin, 0px)",
            width: isEmbeddedConfluence ? "unset" : "var(--full-cover-image-width, 100%)",
            marginTop: "-26px"
        } : {};
        $[0] = isEmbeddedConfluence;
        $[1] = isFixedWidthImageOption;
        $[2] = isPagePreview;
        $[3] = isSmartSpaceOverview;
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] !== children || $[6] !== t4 || $[7] !== t5) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement("div", {
            ...t4,
            className: "renderer-page-cover-picture",
            style: t5,
            "data-vc": "1MfkfPOh"
        }, children);
        $[5] = children;
        $[6] = t4;
        $[7] = t5;
        $[8] = t6;
    } else t6 = $[8];
    return t6;
};
const $250035b51418e050$var$getPageMode = (isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence, isDiffEditor)=>{
    if (isPagePreview) return 'preview';
    else if (isSpaceOverview) return 'space-overview';
    else if (isPresenterMode) return 'presenter';
    else if (isEmbeddedConfluence) return 'embed';
    else if (isDiffEditor) return 'diff-editor';
    else return 'view';
};
const $250035b51418e050$export$d8da1ed12fdbdfd1 = (t0)=>{
    const $ = (0, $frIzR.c)(96);
    const { contentId: contentId, isPagePreview: isPagePreview, coverPicture: coverPicture, contentAppearance: contentAppearance, isSpaceOverview: isSpaceOverview, isSmartSpaceOverview: isSmartSpaceOverview, hasEmoji: hasEmoji, leftRightPaddingValue: leftRightPaddingValue, isPresenterMode: isPresenterMode, coverPictureWidthOverride: coverPictureWidthOverride, isDiffEditor: isDiffEditor, useDraftData: useDraftData } = t0;
    const { isExternalShareRequest: isExternalShare } = (0, $42omo.useContext)((0, $gXrHX.ExternalShareContext));
    const isEmbeddedConfluence = (0, $1iSzD.isEmbeddedConfluence_DO_NOT_USE)();
    const [mediaConfig, setMediaConfig] = (0, $42omo.useState)(null);
    const [hasAllowedExternalImageLoaded, setHasAllowedExternalImageLoaded] = (0, $42omo.useState)(false);
    let t1;
    if ($[0] !== contentId || $[1] !== isExternalShare) {
        t1 = {
            contentId: contentId,
            isExternalShare: isExternalShare
        };
        $[0] = contentId;
        $[1] = isExternalShare;
        $[2] = t1;
    } else t1 = $[2];
    const ssrConfig = (0, $iP9x4.useMediaSSRModeAndAuthConfig)(t1);
    const isServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)(true);
    const isPageSSRed = isServerPlaceholder || window.__SSR_RENDERED__;
    const isMediaConfigGateReady = isPageSSRed ? !!ssrConfig : !!mediaConfig;
    let t2;
    if ($[3] !== isPageSSRed || $[4] !== mediaConfig || $[5] !== ssrConfig) {
        t2 = isPageSSRed ? ssrConfig && ssrConfig.config : mediaConfig && {
            authProvider: mediaConfig.authProvider
        };
        $[3] = isPageSSRed;
        $[4] = mediaConfig;
        $[5] = ssrConfig;
        $[6] = t2;
    } else t2 = $[6];
    const mediaConfigGated = t2;
    let t3;
    if ($[7] !== contentId) {
        t3 = {
            contentId: contentId
        };
        $[7] = contentId;
        $[8] = t3;
    } else t3 = $[8];
    const { titleContentProperties: titleContentProperties, coverPictureWidth: coverPictureWidth } = (0, $zalpJ.useTitleContentPropertiesForPublishedPage)(t3);
    const isFixedWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FIXED || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FIXED;
    const isFixedWidthImageOption = !isPresenterMode && isFixedWidth;
    const isFullWidth = coverPictureWidth === (0, $jVylI.COVERPICTUREWIDTH).FULL || coverPictureWidthOverride === (0, $jVylI.COVERPICTUREWIDTH).FULL;
    const isFullWidthImageOption = !isPresenterMode && isFullWidth;
    const isValidCustomSitesTitleAlignment = titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).CENTER || titleContentProperties?.titleLayoutAlignment == (0, $jVylI.TitleAlignmentType).LEFT;
    const titleAlignment = isValidCustomSitesTitleAlignment && titleContentProperties && titleContentProperties.titleLayoutAlignment ? titleContentProperties.titleLayoutAlignment : "";
    const leftRightPaddingValueOffset = isPagePreview && leftRightPaddingValue ? leftRightPaddingValue : 0;
    const { height: height } = (0, $2XV0z.usePageHeightWidthObserver)(isPagePreview, leftRightPaddingValueOffset, isPresenterMode);
    const smartSpaceOverviewHeight = isSmartSpaceOverview ? (0, $75Ax4.SMART_SPACE_OVERVIEW_FIXED_HEIGHT_FULL_WIDTH) : undefined;
    const dynamicHeight = isFixedWidthImageOption ? (0, $75Ax4.COVER_IMAGE_FIXED_HEIGHT) : height;
    const imageId = (isPagePreview || useDraftData ? coverPicture.draft?.value.id : coverPicture.published?.value.id) || "";
    const position = (isPagePreview || useDraftData ? coverPicture.draft?.value.position : coverPicture.published?.value.position) || "";
    const objectPosition = `center ${position}%`;
    const appearance = isPagePreview ? contentAppearance.draft : contentAppearance.published;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    let t4;
    if ($[9] !== imageId) {
        t4 = !!imageId && (0, $3WPGR.isAllowedExternalCoverPictureUrl)(imageId);
        $[9] = imageId;
        $[10] = t4;
    } else t4 = $[10];
    const isAllowedExternalCoverPicture = t4;
    const currentPageMode = $250035b51418e050$var$getPageMode(isPagePreview, isSpaceOverview, isPresenterMode, isEmbeddedConfluence, isDiffEditor);
    let t5;
    if ($[11] !== createAnalyticsEvent) {
        t5 = (isUnsplash, appearance_0, pageMode, pageTitleAlignment, isFixedWidthCoverImage)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: "viewed",
                    actionSubject: "HeaderImage",
                    actionSubjectId: "viewPageHeaderImage",
                    source: "viewPageHeaderImage",
                    attributes: {
                        headerImageType: isUnsplash ? "unsplash" : "user-uploaded",
                        contentAppearance: appearance_0,
                        pageMode: pageMode,
                        pageTitleAlignment: pageTitleAlignment,
                        coverImageWidth: isFixedWidthCoverImage ? "fixed-width" : "full-width",
                        isAIGenerationEnabled: (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_ai_header_image_generation"),
                        isAIFCAutoGeneratedImageEnabled: (0, $6mKj3.isExperimentEnabled)("cc_page_experiences_aifc_auto_generated_header_img")
                    }
                }
            }).fire();
        };
        $[11] = createAnalyticsEvent;
        $[12] = t5;
    } else t5 = $[12];
    const createViewHeaderImageAnalyticsEvent = t5;
    let t6;
    let t7;
    if ($[13] !== appearance || $[14] !== createViewHeaderImageAnalyticsEvent || $[15] !== currentPageMode || $[16] !== isAllowedExternalCoverPicture || $[17] !== isFixedWidthImageOption || $[18] !== titleAlignment) {
        t6 = ()=>{
            createViewHeaderImageAnalyticsEvent(isAllowedExternalCoverPicture, appearance, currentPageMode, titleAlignment, isFixedWidthImageOption);
        };
        t7 = [
            isAllowedExternalCoverPicture,
            appearance,
            currentPageMode,
            titleAlignment,
            isFixedWidthImageOption,
            createViewHeaderImageAnalyticsEvent
        ];
        $[13] = appearance;
        $[14] = createViewHeaderImageAnalyticsEvent;
        $[15] = currentPageMode;
        $[16] = isAllowedExternalCoverPicture;
        $[17] = isFixedWidthImageOption;
        $[18] = titleAlignment;
        $[19] = t6;
        $[20] = t7;
    } else {
        t6 = $[19];
        t7 = $[20];
    }
    (0, $42omo.useEffect)(t6, t7);
    let t8;
    if ($[21] !== contentId || $[22] !== isExternalShare || $[23] !== setMediaConfig) {
        t8 = ()=>{
            let isMounted = true;
            setMediaConfig(null);
            (0, $4IoVL.createRendererMediaProvider)({
                contentId: contentId,
                isExternalShare: isExternalShare
            }).then((t9)=>{
                const { viewMediaClientConfig: viewMediaClientConfig } = t9;
                if (isMounted) setMediaConfig({
                    collection: `contentId-${contentId}`,
                    authProvider: viewMediaClientConfig.authProvider
                });
            });
            return ()=>{
                isMounted = false;
            };
        };
        $[21] = contentId;
        $[22] = isExternalShare;
        $[23] = setMediaConfig;
        $[24] = t8;
    } else t8 = $[24];
    let t9;
    if ($[25] !== contentId || $[26] !== isExternalShare) {
        t9 = [
            contentId,
            isExternalShare
        ];
        $[25] = contentId;
        $[26] = isExternalShare;
        $[27] = t9;
    } else t9 = $[27];
    (0, $42omo.useEffect)(t8, t9);
    if (!isMediaConfigGateReady || !imageId && !isAllowedExternalCoverPicture) {
        let t10;
        if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            $[28] = t10;
        } else t10 = $[28];
        let t11;
        if ($[29] !== isFixedWidthImageOption || $[30] !== isPagePreview || $[31] !== isSpaceOverview || $[32] !== smartSpaceOverviewHeight) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$caf7b844f87776ef, {
                isPagePreview: isPagePreview,
                isSpaceOverview: isSpaceOverview,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                isObjectHeaderEnabled: t10
            });
            $[29] = isFixedWidthImageOption;
            $[30] = isPagePreview;
            $[31] = isSpaceOverview;
            $[32] = smartSpaceOverviewHeight;
            $[33] = t11;
        } else t11 = $[33];
        let t12;
        if ($[34] !== isEmbeddedConfluence || $[35] !== isFixedWidthImageOption || $[36] !== isPagePreview || $[37] !== isSmartSpaceOverview || $[38] !== t11) {
            t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                isPagePreview: isPagePreview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption,
                isSmartSpaceOverview: isSmartSpaceOverview
            }, t11);
            $[34] = isEmbeddedConfluence;
            $[35] = isFixedWidthImageOption;
            $[36] = isPagePreview;
            $[37] = isSmartSpaceOverview;
            $[38] = t11;
            $[39] = t12;
        } else t12 = $[39];
        return t12;
    }
    if (isAllowedExternalCoverPicture) {
        let t10;
        if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
            t10 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            $[40] = t10;
        } else t10 = $[40];
        let t11;
        if ($[41] !== hasAllowedExternalImageLoaded || $[42] !== isEmbeddedConfluence || $[43] !== isFixedWidthImageOption || $[44] !== isPagePreview || $[45] !== isSpaceOverview || $[46] !== smartSpaceOverviewHeight) {
            t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$4f4221086883a54f, {
                isPagePreview: isPagePreview,
                hasAllowedExternalImageLoaded: hasAllowedExternalImageLoaded,
                isSpaceOverview: isSpaceOverview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                isObjectHeaderEnabled: t10
            });
            $[41] = hasAllowedExternalImageLoaded;
            $[42] = isEmbeddedConfluence;
            $[43] = isFixedWidthImageOption;
            $[44] = isPagePreview;
            $[45] = isSpaceOverview;
            $[46] = smartSpaceOverviewHeight;
            $[47] = t11;
        } else t11 = $[47];
        let t12;
        if ($[48] !== setHasAllowedExternalImageLoaded) {
            t12 = ()=>{
                setHasAllowedExternalImageLoaded(true);
            };
            $[48] = setHasAllowedExternalImageLoaded;
            $[49] = t12;
        } else t12 = $[49];
        const t13 = isPresenterMode ? dynamicHeight : undefined;
        let t14;
        if ($[50] === Symbol.for("react.memo_cache_sentinel")) {
            t14 = (0, $9wGTI.fg)("confluence_frontend_content_wrapper");
            $[50] = t14;
        } else t14 = $[50];
        let t15;
        if ($[51] !== hasEmoji || $[52] !== imageId || $[53] !== isFixedWidthImageOption || $[54] !== isFullWidthImageOption || $[55] !== isPagePreview || $[56] !== isPresenterMode || $[57] !== isSmartSpaceOverview || $[58] !== isSpaceOverview || $[59] !== objectPosition || $[60] !== smartSpaceOverviewHeight || $[61] !== t12 || $[62] !== t13) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$75f07c36086c2c81, {
                "data-testid": "unsplash-cover-picture",
                "data-vc": "unsplash-cover-picture-renderer",
                alt: "",
                isPagePreview: isPagePreview,
                src: imageId,
                objectPosition: objectPosition,
                onLoad: t12,
                isSpaceOverview: isSpaceOverview,
                isRoundedCorners: isSmartSpaceOverview,
                hasEmoji: hasEmoji,
                dynamicCoverImageHeight: undefined,
                presenterModeHeight: t13,
                isPresenterMode: isPresenterMode,
                isFixedWidthImageOption: isFixedWidthImageOption,
                smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                isFullWidthImageOption: isFullWidthImageOption,
                isObjectHeaderEnabled: t14
            });
            $[51] = hasEmoji;
            $[52] = imageId;
            $[53] = isFixedWidthImageOption;
            $[54] = isFullWidthImageOption;
            $[55] = isPagePreview;
            $[56] = isPresenterMode;
            $[57] = isSmartSpaceOverview;
            $[58] = isSpaceOverview;
            $[59] = objectPosition;
            $[60] = smartSpaceOverviewHeight;
            $[61] = t12;
            $[62] = t13;
            $[63] = t15;
        } else t15 = $[63];
        let t16;
        if ($[64] !== imageId || $[65] !== t11 || $[66] !== t15) {
            t16 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$AllowedExternalWrapper, {
                key: imageId
            }, t11, t15);
            $[64] = imageId;
            $[65] = t11;
            $[66] = t15;
            $[67] = t16;
        } else t16 = $[67];
        let t17;
        if ($[68] !== isEmbeddedConfluence || $[69] !== isFixedWidthImageOption || $[70] !== isPagePreview || $[71] !== isSmartSpaceOverview || $[72] !== t16) {
            t17 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                isPagePreview: isPagePreview,
                isEmbeddedConfluence: isEmbeddedConfluence,
                isFixedWidthImageOption: isFixedWidthImageOption,
                isSmartSpaceOverview: isSmartSpaceOverview
            }, t16);
            $[68] = isEmbeddedConfluence;
            $[69] = isFixedWidthImageOption;
            $[70] = isPagePreview;
            $[71] = isSmartSpaceOverview;
            $[72] = t16;
            $[73] = t17;
        } else t17 = $[73];
        return t17;
    } else if (isMediaConfigGateReady && mediaConfigGated) {
        const t10 = isPageSSRed ? `contentId-${contentId}` : mediaConfig?.collection;
        let t11;
        if ($[74] !== imageId || $[75] !== t10) {
            t11 = {
                mediaItemType: "file",
                id: imageId,
                collectionName: t10
            };
            $[74] = imageId;
            $[75] = t10;
            $[76] = t11;
        } else t11 = $[76];
        let t12;
        if ($[77] === Symbol.for("react.memo_cache_sentinel")) {
            t12 = {
                allowAnimated: true,
                mode: "full-fit",
                upscale: false
            };
            $[77] = t12;
        } else t12 = $[77];
        const t13 = isPageSSRed ? ssrConfig?.mode : undefined;
        let t14;
        if ($[78] !== dynamicHeight || $[79] !== hasEmoji || $[80] !== isEmbeddedConfluence || $[81] !== isFixedWidthImageOption || $[82] !== isFullWidthImageOption || $[83] !== isPagePreview || $[84] !== isPresenterMode || $[85] !== isSmartSpaceOverview || $[86] !== isSpaceOverview || $[87] !== objectPosition || $[88] !== smartSpaceOverviewHeight) {
            t14 = (t15)=>{
                const { data: data, loading: loading } = t15;
                if (loading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                    isPagePreview: isPagePreview,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    isSmartSpaceOverview: isSmartSpaceOverview
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$caf7b844f87776ef, {
                    isPagePreview: isPagePreview,
                    isSpaceOverview: isSpaceOverview,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                    isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper")
                }));
                if (!data) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$var$IdentifierWrapper, {
                    isPagePreview: isPagePreview,
                    isEmbeddedConfluence: isEmbeddedConfluence,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    isSmartSpaceOverview: isSmartSpaceOverview
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($250035b51418e050$export$75f07c36086c2c81, {
                    isPagePreview: isPagePreview,
                    src: data.src,
                    objectPosition: objectPosition,
                    isSpaceOverview: isSpaceOverview,
                    isRoundedCorners: isSmartSpaceOverview,
                    hasEmoji: hasEmoji,
                    dynamicCoverImageHeight: undefined,
                    presenterModeHeight: isPresenterMode ? dynamicHeight : undefined,
                    isPresenterMode: isPresenterMode,
                    isFixedWidthImageOption: isFixedWidthImageOption,
                    smartSpaceOverviewHeight: smartSpaceOverviewHeight,
                    isFullWidthImageOption: isFullWidthImageOption,
                    isObjectHeaderEnabled: (0, $9wGTI.fg)("confluence_frontend_content_wrapper"),
                    alt: ""
                }));
            };
            $[78] = dynamicHeight;
            $[79] = hasEmoji;
            $[80] = isEmbeddedConfluence;
            $[81] = isFixedWidthImageOption;
            $[82] = isFullWidthImageOption;
            $[83] = isPagePreview;
            $[84] = isPresenterMode;
            $[85] = isSmartSpaceOverview;
            $[86] = isSpaceOverview;
            $[87] = objectPosition;
            $[88] = smartSpaceOverviewHeight;
            $[89] = t14;
        } else t14 = $[89];
        let t15;
        if ($[90] !== imageId || $[91] !== mediaConfigGated || $[92] !== t11 || $[93] !== t13 || $[94] !== t14) {
            t15 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $btHGY.MediaImageWithErrorBoundary), {
                key: imageId,
                identifier: t11,
                mediaClientConfig: mediaConfigGated,
                apiConfig: t12,
                ssr: t13
            }, t14);
            $[90] = imageId;
            $[91] = mediaConfigGated;
            $[92] = t11;
            $[93] = t13;
            $[94] = t14;
            $[95] = t15;
        } else t15 = $[95];
        return t15;
    }
};
const $250035b51418e050$export$60620c3d63f5f30 = (0, $aJv6Q.withTransparentErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).PAGE_EXTENSIONS
})($250035b51418e050$export$d8da1ed12fdbdfd1);
module.exports["ImageWrapper"] = $250035b51418e050$export$75f07c36086c2c81;
module.exports["LoadingDiv"] = $250035b51418e050$export$caf7b844f87776ef;
module.exports["AllowedExternalLoadingDiv"] = $250035b51418e050$export$4f4221086883a54f;
module.exports["RendererPageCoverPictureComponent"] = $250035b51418e050$export$d8da1ed12fdbdfd1;
module.exports["RendererPageCoverPicture"] = $250035b51418e050$export$60620c3d63f5f30;

});

parcelRegister("e4o8D", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $6mKj3 = parcelRequire("6mKj3");


var $1NBp8 = parcelRequire("1NBp8");


var $60cDW = parcelRequire("60cDW");

const $2679ebd914f0a083$var$emptySubscribe = ()=>()=>{};
const $2679ebd914f0a083$var$getClientSnapshot = ()=>false;
const $2679ebd914f0a083$var$getServerSnapshot = ()=>true;
const $2679ebd914f0a083$var$editRoutes = [
    (0, $1NBp8.EDIT_PAGE_V2),
    (0, $1NBp8.EDIT_BLOG_V2),
    (0, $1NBp8.EDIT_PAGE),
    (0, $1NBp8.EDIT_BLOG),
    (0, $1NBp8.EDIT_PAGE_EMBED)
];
const $2679ebd914f0a083$var$isEditOrLiveRoute = ()=>{
    const { uri: uri, isLivePage: isLivePage } = (0, $60cDW.getSSRRenderInputs)();
    if (isLivePage) return true;
    if (uri) return $2679ebd914f0a083$var$editRoutes.some((route)=>route.match(uri));
    return false;
};
const $2679ebd914f0a083$export$96e8e9e8e57310bb = (t0)=>{
    const $ = (0, $frIzR.c)(5);
    const renderServerPlaceholderOnNonHydrate = t0 === undefined ? false : t0;
    const isSSRSync = (0, $42omo.useSyncExternalStore)($2679ebd914f0a083$var$emptySubscribe, $2679ebd914f0a083$var$getClientSnapshot, $2679ebd914f0a083$var$getServerSnapshot);
    const optimizedRenderServerPlaceholder = (0, $42omo.useDeferredValue)(isSSRSync);
    const isTransition = window.__SSR_RENDERED__ === false;
    const [renderServerPlaceholder, setRenderServerPlaceholder] = (0, $42omo.useState)(renderServerPlaceholderOnNonHydrate ? !isTransition || Boolean(undefined) : window?.__HYDRATABLE__ && !isTransition || Boolean(undefined));
    let t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = ()=>{
            if ($2679ebd914f0a083$var$isEditOrLiveRoute() || !(0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false)) setRenderServerPlaceholder(false);
        };
        t2 = [];
        $[0] = t1;
        $[1] = t2;
    } else {
        t1 = $[0];
        t2 = $[1];
    }
    (0, $42omo.useEffect)(t1, t2);
    let t3;
    if ($[2] !== optimizedRenderServerPlaceholder || $[3] !== renderServerPlaceholder) {
        t3 = !$2679ebd914f0a083$var$isEditOrLiveRoute() && (0, $6mKj3.expVal)("confluence_optimize_render_server_placeholder", "isEnabled", false) ? optimizedRenderServerPlaceholder : renderServerPlaceholder;
        $[2] = optimizedRenderServerPlaceholder;
        $[3] = renderServerPlaceholder;
        $[4] = t3;
    } else t3 = $[4];
    return t3;
};
module.exports["useRenderServerPlaceholder"] = $2679ebd914f0a083$export$96e8e9e8e57310bb;

});

parcelRegister("gXrHX", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $k3pHv = parcelRequire("k3pHv");

const $a357cfbdfa4d3d24$export$74d34469a946b330 = /*#__PURE__*/ (0, $42omo.createContext)({
    isExternalShareRequest: false,
    userType: (0, $k3pHv.UserTypes).ANONYMOUS,
    shareToken: undefined,
    isAccessLinkRequest: false
});
module.exports["ExternalShareContext"] = $a357cfbdfa4d3d24$export$74d34469a946b330;

});

parcelRegister("k3pHv", function(module, exports) {
var $dcb154d9b517823f$export$df06b7fc047181f5 = /*#__PURE__*/ function(UserTypes) {
    // Anonymous users, not logged in
    UserTypes["ANONYMOUS"] = "anonymous";
    // Logged in, not Confluence user - member in the org
    UserTypes["ORG_MEMBER"] = "org-member";
    // Logged in, Licensed Confluence user
    UserTypes["CONFLUENCE_USER"] = "confluence-user";
    // Logged in, Atlassian user not in the org
    UserTypes["ATLASSIAN_USER"] = "atlassian-user";
    return UserTypes;
}({});
module.exports["UserTypes"] = $dcb154d9b517823f$export$df06b7fc047181f5;

});

parcelRegister("luv00", function(module, exports) {

var $3u0dr = parcelRequire("3u0dr");


var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $5nSna = parcelRequire("5nSna");

const $8a88875ffe13fd4c$export$30b62f74ca853d7d = (0, $3u0dr.isReactCompilerActiveV2)() ? function useSSRPlaceholderReplaceIdProp() {
    const $ = (0, $frIzR.c)(2);
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    let t0;
    if ($[0] !== placeholderReplaceId) {
        t0 = {
            "data-ssr-placeholder-replace": placeholderReplaceId
        };
        $[0] = placeholderReplaceId;
        $[1] = t0;
    } else t0 = $[1];
    return t0;
} : function useSSRPlaceholderReplaceIdProp() {
    const { placeholderReplaceId: placeholderReplaceId } = (0, $42omo.useContext)((0, $5nSna.LoadableAncestorsContext));
    return {
        'data-ssr-placeholder-replace': placeholderReplaceId
    };
};
module.exports["useSSRPlaceholderReplaceIdProp"] = $8a88875ffe13fd4c$export$30b62f74ca853d7d;

});

parcelRegister("2XV0z", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $cMvQV = parcelRequire("cMvQV");


var $3WPGR = parcelRequire("3WPGR");

const $8c9f801fa4f4ae90$export$a5c14cb4205739db = (isPagePreview, leftRightPaddingValueOffset, isPresenterMode)=>{
    const $ = (0, $frIzR.c)(9);
    const [height, setHeight] = (0, $42omo.useState)(0);
    const [width, setWidth] = (0, $42omo.useState)(0);
    const [leftOffset, setLeftOffset] = (0, $42omo.useState)(0);
    const observerRef = (0, $42omo.useRef)(null);
    let t0;
    let t1;
    if ($[0] !== isPagePreview || $[1] !== isPresenterMode || $[2] !== leftOffset || $[3] !== leftRightPaddingValueOffset) {
        t0 = ()=>{
            let queryId;
            if (isPresenterMode) queryId = "[id='presenter-mode-header-image-container']";
            else if (isPagePreview) queryId = "[id='header-row-wrapper']";
            else queryId = ".content-screen-component";
            const pageScrollParent = document.querySelector(queryId);
            if (pageScrollParent) {
                observerRef.current = new ResizeObserver((entries)=>{
                    if ((0, $cMvQV.isChrome)() || (0, $cMvQV.isSafari)()) {
                        const innerWidth = Math.floor(entries[0]?.target.clientWidth);
                        const outerWidth = Math.floor(entries[0]?.borderBoxSize?.[0].inlineSize);
                        if (outerWidth > innerWidth) setLeftOffset(outerWidth - innerWidth);
                    }
                    const currentWidth = Math.floor(entries[0]?.target.clientWidth) - leftOffset - leftRightPaddingValueOffset;
                    setWidth(currentWidth);
                    setHeight((0, $3WPGR.getDynamicCoverImageHeight)(currentWidth));
                });
                observerRef.current.observe(pageScrollParent);
                return ()=>observerRef?.current?.disconnect();
            }
        };
        t1 = [
            observerRef,
            leftOffset,
            isPagePreview,
            leftRightPaddingValueOffset,
            isPresenterMode
        ];
        $[0] = isPagePreview;
        $[1] = isPresenterMode;
        $[2] = leftOffset;
        $[3] = leftRightPaddingValueOffset;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $42omo.useEffect)(t0, t1);
    let t2;
    if ($[6] !== height || $[7] !== width) {
        t2 = {
            height: height,
            width: width
        };
        $[6] = height;
        $[7] = width;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
};
module.exports["usePageHeightWidthObserver"] = $8c9f801fa4f4ae90$export$a5c14cb4205739db;

});

parcelRegister("iTcHJ", function(module, exports) {
/**
 * @generated SignedSource<<ad7f8916cadafdf5756ee8bd1ad40682>>
 * @relayHash 60dcb7a4a06a5eaa2ddb4f4df7437c8c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076
const $cd49b7baa8bd0c54$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": false,
        "kind": "LocalArgument",
        "name": "missingContentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "status"
    }, v3 = [
        {
            "condition": "missingContentId",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "id",
                            "variableName": "contentId"
                        },
                        {
                            "kind": "Variable",
                            "name": "status",
                            "variableName": "status"
                        }
                    ],
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                },
                                {
                                    "concreteType": "ContentBodyPerRepresentation",
                                    "kind": "LinkedField",
                                    "name": "body",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "ContentBody",
                                            "kind": "LinkedField",
                                            "name": "atlas_doc_format",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "concreteType": "EmbeddedMediaToken",
                                                    "kind": "LinkedField",
                                                    "name": "mediaToken",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "token"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "concreteType": "MediaConfiguration",
            "kind": "LinkedField",
            "name": "mediaConfiguration",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientId"
                },
                {
                    "kind": "ScalarField",
                    "name": "fileStoreUrl"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "60dcb7a4a06a5eaa2ddb4f4df7437c8c",
            "id": "da295508da11933cde6015c5899a2dae3ede521437117bf85391f779f362e076",
            "metadata": {},
            "name": "graphqlHelpersFetchMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchMediaTokenQuery($contentId:ID,$status:[String],$missingContentId:Boolean=false){content(id:$contentId,status:$status)@skip(if:$missingContentId){nodes{id,body{atlas_doc_format{mediaToken{token}}}}},mediaConfiguration{clientId,fileStoreUrl}}"
        }
    };
}();
$cd49b7baa8bd0c54$var$node.hash = "c53e0852d23c6b17549e89592c16b84c";
var $cd49b7baa8bd0c54$export$2e2bcd8739ae039 = $cd49b7baa8bd0c54$var$node;
module.exports["default"] = $cd49b7baa8bd0c54$export$2e2bcd8739ae039;

});

parcelRegister("6IsMq", function(module, exports) {
/**
 * @generated SignedSource<<782a202a95cb3894b03a17351d1d4a69>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b
const $684f397ef7ad0ae2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueAri"
        },
        {
            "defaultValue": 65536,
            "kind": "LocalArgument",
            "name": "maxTokenLength"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "issueAri"
        }
    ], v2 = {
        "args": [
            {
                "kind": "Variable",
                "name": "maxTokenLength",
                "variableName": "maxTokenLength"
            }
        ],
        "concreteType": "JiraMediaReadToken",
        "kind": "LinkedField",
        "name": "mediaReadToken",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "clientId"
            },
            {
                "kind": "ScalarField",
                "name": "endpointUrl"
            },
            {
                "kind": "ScalarField",
                "name": "tokenLifespanInSeconds"
            },
            {
                "concreteType": "JiraMediaTokenWithFilesConnection",
                "kind": "LinkedField",
                "name": "tokensWithFiles",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JiraMediaTokenWithFilesEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                            {
                                "concreteType": "JiraMediaTokenWithFiles",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "token"
                                    }
                                ]
                            }
                        ]
                    }
                ]
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueById",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
            "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
            "metadata": {},
            "name": "graphqlHelpersFetchJiraMediaTokenQuery",
            "operationKind": "query",
            "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
        }
    };
}();
$684f397ef7ad0ae2$var$node.hash = "7036cf95096a08504e6375127746a507";
var $684f397ef7ad0ae2$export$2e2bcd8739ae039 = $684f397ef7ad0ae2$var$node;
module.exports["default"] = $684f397ef7ad0ae2$export$2e2bcd8739ae039;

});

parcelRegister("k2in1", function(module, exports) {
const $70107457754d8ab2$var$MAX_RETRY_DELAY = 30000;
const $70107457754d8ab2$var$parseRetryAfter = (retryAfter)=>{
    // retryAfter can either be in seconds or HTTP date
    const parsedRetryAfter = parseInt(retryAfter, 10);
    if (!isNaN(parsedRetryAfter) && parsedRetryAfter > 0) return parsedRetryAfter * 1000;
    const retryDate = new Date(retryAfter);
    if (isNaN(retryDate.getTime())) return undefined;
    const delayFromDate = retryDate.getTime() - Date.now();
    if (delayFromDate > 0) return delayFromDate;
    return undefined;
};
const $70107457754d8ab2$export$cffaac380b94df26 = async (url, options, retriesRemaining = 3, delay = 1000)=>{
    const response = await fetch(url, options);
    const shouldRetry = !response.ok && response.status === 429 && retriesRemaining > 1;
    if (!shouldRetry) return response;
    const retryAfter = response.headers.get('Retry-After');
    const parsedDelay = (retryAfter ? $70107457754d8ab2$var$parseRetryAfter(retryAfter) : undefined) ?? delay;
    const retryDelay = Math.min(parsedDelay, $70107457754d8ab2$var$MAX_RETRY_DELAY);
    await new Promise((resolve)=>setTimeout(resolve, retryDelay));
    return $70107457754d8ab2$export$cffaac380b94df26(url, options, retriesRemaining - 1, delay * 2);
};
module.exports["fetchWithRetry"] = $70107457754d8ab2$export$cffaac380b94df26;

});

parcelRegister("aBfpe", function(module, exports) {
/**
 * https://www.iana.org/assignments/media-types/media-types.xhtml
 */ var $c27c52d002752847$export$483c11740a902fcd = /*#__PURE__*/ function(MediaType) {
    MediaType["JSON"] = "application/json";
    MediaType["X_WWW_FORM_URLENCODED"] = "application/x-www-form-urlencoded";
    return MediaType;
}({});
module.exports["MediaType"] = $c27c52d002752847$export$483c11740a902fcd;

});

parcelRegister("9ILXP", function(module, exports) {
function $713d6dc98197981e$var$e(e) {
    this.message = e;
}
$713d6dc98197981e$var$e.prototype = new Error, $713d6dc98197981e$var$e.prototype.name = "InvalidCharacterError";
var $713d6dc98197981e$var$r = "undefined" != typeof window && window.atob && window.atob.bind(window) || function(r) {
    var t = String(r).replace(/=+$/, "");
    if (t.length % 4 == 1) throw new $713d6dc98197981e$var$e("'atob' failed: The string to be decoded is not correctly encoded.");
    for(var n, o, a = 0, i = 0, c = ""; o = t.charAt(i++); ~o && (n = a % 4 ? 64 * n + o : o, a++ % 4) && (c += String.fromCharCode(255 & n >> (-2 * a & 6))))o = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(o);
    return c;
};
function $713d6dc98197981e$var$t(e) {
    var t = e.replace(/-/g, "+").replace(/_/g, "/");
    switch(t.length % 4){
        case 0:
            break;
        case 2:
            t += "==";
            break;
        case 3:
            t += "=";
            break;
        default:
            throw "Illegal base64url string!";
    }
    try {
        return function(e) {
            return decodeURIComponent($713d6dc98197981e$var$r(e).replace(/(.)/g, function(e, r) {
                var t = r.charCodeAt(0).toString(16).toUpperCase();
                return t.length < 2 && (t = "0" + t), "%" + t;
            }));
        }(t);
    } catch (e) {
        return $713d6dc98197981e$var$r(t);
    }
}
function $713d6dc98197981e$export$b9721ef022f71a68(e) {
    this.message = e;
}
function $713d6dc98197981e$var$o(e, r) {
    if ("string" != typeof e) throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified");
    var o = !0 === (r = r || {}).header ? 0 : 1;
    try {
        return JSON.parse($713d6dc98197981e$var$t(e.split(".")[o]));
    } catch (e) {
        throw new $713d6dc98197981e$export$b9721ef022f71a68("Invalid token specified: " + e.message);
    }
}
$713d6dc98197981e$export$b9721ef022f71a68.prototype = new Error, $713d6dc98197981e$export$b9721ef022f71a68.prototype.name = "InvalidTokenError";
var $713d6dc98197981e$export$2e2bcd8739ae039 = $713d6dc98197981e$var$o;
module.exports["default"] = $713d6dc98197981e$export$2e2bcd8739ae039;

});

parcelRegister("4GGNn", function(module, exports) {

var $jhbO3 = parcelRequire("jhbO3");


var $GLgaM = parcelRequire("GLgaM");


var $bjeS8 = parcelRequire("bjeS8");

async function $aeaa62655b9da260$export$4199ef03ec2aea3f({ url: url, method: method, headers: headers, body: body, credentials: credentials, variables: variables, parseResult: parseResult, parseResponseOnSuccess: parseResponseOnSuccess, parseResponseOnError: parseResponseOnError, onCompleted: onCompleted, onError: onError, transformError: transformError }) {
    const fetchData = async ()=>{
        const json = await (0, $GLgaM.fetchResponse)({
            url: url,
            method: method,
            body: body,
            headers: headers,
            credentials: credentials,
            parseResponseOnSuccess: parseResponseOnSuccess,
            parseResponseOnError: parseResponseOnError
        }, variables);
        return await parseResult(json, variables);
    };
    const handleConvertToApolloError = async (error)=>{
        return (0, $bjeS8.convertToApolloError)(await transformError?.(error) || error);
    };
    return (0, $jhbO3.apolloCompatibleMutation)({
        fetchData: fetchData,
        onCompleted: onCompleted,
        onError: onError,
        convertToApolloError: handleConvertToApolloError
    });
}
module.exports["experimentalMutate"] = $aeaa62655b9da260$export$4199ef03ec2aea3f;

});

parcelRegister("9k33u", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $grxv4 = parcelRequire("grxv4");


var $8IHds = parcelRequire("8IHds");

const $93e9546cb0a1512c$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createContext(undefined);
const $93e9546cb0a1512c$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $42omo.useMemo)(()=>(0, $grxv4.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $8IHds.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($93e9546cb0a1512c$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        }
    }, children);
};
module.exports["MediaContext"] = $93e9546cb0a1512c$export$c94ff18a59d4c4d;
module.exports["MediaProvider"] = $93e9546cb0a1512c$export$57164260bc1f1218;

});

parcelRegister("8IHds", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $82Dle = parcelRequire("82Dle");

const $ad9bb6183b9f6f81$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $42omo.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $82Dle.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};
module.exports["useMediaParsedSettings"] = $ad9bb6183b9f6f81$export$d54af28440a5efc0;

});

parcelRegister("82Dle", function(module, exports) {
// Currently only supports boolean, string. Uncomment below to support number
const $3a61632aaf261ebb$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $3a61632aaf261ebb$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($3a61632aaf261ebb$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $3a61632aaf261ebb$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $3a61632aaf261ebb$export$2d23ed2854ac1650 = $3a61632aaf261ebb$export$7e209e67b965bc63($3a61632aaf261ebb$var$defaultUserPreferences);
module.exports["defaultMediaUserPreferences"] = $3a61632aaf261ebb$export$2d23ed2854ac1650;

});

parcelRegister("jRNsq", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $3rvSa = parcelRequire("3rvSa");


var $9k33u = parcelRequire("9k33u");

const $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $3rvSa.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).useContext((0, $9k33u.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};
module.exports["useMediaClient"] = $9c13c2ba0d10a1f7$export$8b3e87ea56c3a345;

});

parcelRegister("i2CQL", function(module, exports) {

var $g99e4 = parcelRequire("g99e4");


var $jRNsq = parcelRequire("jRNsq");

const $4af3bbf76333cbc2$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $g99e4.useStore)(store, selector, equals);
function $4af3bbf76333cbc2$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $jRNsq.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $4af3bbf76333cbc2$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}
module.exports["useMediaStore"] = $4af3bbf76333cbc2$export$8a9cc8c330400af8;

});

parcelRegister("g99e4", function(module, exports) {
$parcel$export(module.exports, "useStore", () => $bc14a4aa688fca7b$export$6ccbb43953eebf8);

var $9mu1x = parcelRequire("9mu1x");


var $42omo = parcelRequire("42omo");


var $hpRUx = parcelRequire("hpRUx");

var $bc14a4aa688fca7b$import_meta = Object.assign(Object.create(null), {
    url: "file:///../platform/node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $bc14a4aa688fca7b$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($42omo)));
const { useSyncExternalStoreWithSelector: $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($hpRUx)));
let $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = false;
const $bc14a4aa688fca7b$var$identity = (arg)=>arg;
function $bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector = $bc14a4aa688fca7b$var$identity, equalityFn) {
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$bc14a4aa688fca7b$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $bc14a4aa688fca7b$var$didWarnAboutEqualityFn = true;
    }
    const slice = $bc14a4aa688fca7b$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $bc14a4aa688fca7b$var$useDebugValue(slice);
    return slice;
}
const $bc14a4aa688fca7b$var$createImpl = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $9mu1x.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$bc14a4aa688fca7b$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $bc14a4aa688fca7b$export$185802fd694ee1f5 = (createState)=>createState ? $bc14a4aa688fca7b$var$createImpl(createState) : $bc14a4aa688fca7b$var$createImpl;
var $bc14a4aa688fca7b$export$2e2bcd8739ae039 = (createState)=>{
    if (($bc14a4aa688fca7b$import_meta.env ? $bc14a4aa688fca7b$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $bc14a4aa688fca7b$export$185802fd694ee1f5(createState);
};

});

parcelRegister("5yfLD", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});


//# sourceMappingURL=RendererPageCoverPicture.e8b7d912.js.map
